import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ConditionsPage from './pages/ConditionsPage';
import ConditionDetailPage from './pages/ConditionDetails';
import ChatWidget from './components/ChatWidget';
import { AboutPage, ContactPage, AccessibilityPage, PrivacyPage, TermsPage } from './pages/StaticPages';

function App() {
  return (
    <BrowserRouter>
      <ChatWidget />
      <Routes>
        <Route path="/"              element={<HomePage />} />
        <Route path="/conditions"    element={<ConditionsPage />} />
        <Route path="/conditions/:id" element={<ConditionDetailPage />} />
        <Route path="/about"         element={<AboutPage />} />
        <Route path="/privacy"       element={<PrivacyPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/contact"       element={<ContactPage />} />
        <Route path="/terms"         element={<TermsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;